/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
var beforePrimaryToolbarPluginWrapperStyles = css({
  display: 'flex',
  marginRight: "var(--ds-space-100, 8px)",
  flexGrow: 1,
  justifyContent: 'flex-end',
  alignItems: 'center'
});
export var BeforePrimaryToolbarWrapper = function BeforePrimaryToolbarWrapper(props) {
  return jsx("div", {
    css: beforePrimaryToolbarPluginWrapperStyles,
    "data-testid": 'before-primary-toolbar-components-plugin'
  }, props.beforePrimaryToolbarComponents);
};